/**
 * @file Decode HTML entities for safe React text display (textarea trick).
 */

export const decodeHtmlEntities = (text) => {
  if (!text || typeof text !== 'string') {
    return text;
  }
  
  const textarea = document.createElement('textarea');
  // REVIEW [MEDIUM]: Assigning untrusted strings to textarea.innerHTML can parse markup;
  // safe only because callers render the result as React text (escaped), never as HTML.
  textarea.innerHTML = text;
  return textarea.value;
};



